export const buildCompanyStatusCriteria = (companyId, status = "ACTIVE", extra = {}) => ({
  company: {
    primaryId: companyId
  },
  status,
  ...extra
});

export const buildServiceProductCriteria = (companyId) => (
  buildCompanyStatusCriteria(companyId, "ACTIVE", {
    type: {
      typeCode: "SERVICE"
    }
  })
);

export const buildCurriculumCriteria = (productId, entitiesToSkip = []) => ({
  product: {
    primaryId: productId
  },
  entitiesToSkip
});

export const buildUserCurriculumCriteria = ({
  userId,
  scheduledProductId,
  companyId,
  type,
  deliverySubType,
  entitiesToSkip = [],
  primaryId
}) => {
  const isNestedVirtualProduct = type === "VIRTUAL" && deliverySubType !== "INSTRUCTOR_LED";

  return {
    user: { primaryId: userId },
    product: isNestedVirtualProduct
      ? { product: { primaryId: scheduledProductId } }
      : { primaryId: scheduledProductId },
    company: { primaryId: companyId },
    entitiesToSkip,
    primaryId
  };
};

export const buildUserCurriculumByIdCriteria = (primaryId, entitiesToSkip = []) => ({
  primaryId,
  entitiesToSkip
});

export const buildScheduledProductCriteria = (productId, status = "ACTIVE") => ({
  product: {
    primaryId: productId
  },
  status
});

export const buildProductCategoryCriteria = (companyId, type = "REGULAR") => (
  buildCompanyStatusCriteria(companyId, "ACTIVE", { type })
);

export const buildAllValidProductsCriteria = (companyId, categoryId = null) => ({
  company: {
    primaryId: companyId
  },
  ...(categoryId ? { category: { primaryId: categoryId } } : {})
});

export const buildSelfPacedValidProductsCriteria = (companyId, categoryId = null) => ({
  company: {
    primaryId: companyId
  },
  status: "ACTIVE",
  deliveryType: "VIRTUAL",
  deliverySubType: "SELF_PACED",
  ...(categoryId ? { product: { category: { primaryId: categoryId } } } : {})
});

export const buildUpcomingProductsCriteria = (companyId, categoryId = null) => ({
  company: {
    primaryId: companyId
  },
  status: "UPCOMING",
  ...(categoryId ? { product: { category: { primaryId: categoryId } } } : {})
});

export const buildMaxCapacityCriteria = (categoryId, companyId) => ({
  primaryId: categoryId,
  company: {
    primaryId: companyId
  }
});

export const buildDurationCriteria = (daysOfSchedule, startTime, endTime, totalHours) => ({
  daysOfSchedule,
  startTime,
  endTime,
  totalHours
});
